<div class="uploader-wrapper w-100">
  <div class="d-flex">
    <div class="flex-1">
      <h6 class="m-0" *ngIf="uploaderLabel">
        <span class="fs-sm color-navi medium">
          <span>{{uploaderLabel}}</span>
          <span *ngIf="isRequired" class="color-error">*</span>:</span>
        <span *ngIf="files.length"
              class="badge file-number-badge ml-h"><span class="medium">{{files.length}}</span></span>
      </h6>
    </div>
    <div *ngIf="showDownloadAll" class="flex-0 p-0 d-flex ai-center jc-end">
      <button *ngIf="files && files.length" class="reset-button link p-0" type="button"
              [attr.data-test-id]="[testId, 'button_download_all'] | join"
              [disabled]="files.length === 0"
              (click)="downloadAll()">
        <span class="icon icon-download mr-h"></span>
        <span class="truncate">{{'common.label.download-all' | translate}}</span>
      </button>
    </div>
  </div>
  <div class="container default-dnd-container d-flex column jc-around mb-1" appDnd (fileDropped)="onFileDropped($event)">
    <input type="file" #fileDropRef id="fileDropRef_{{itemToLinkId || testId}}" multiple
           [disabled]="isDisabled"
           [accept]="fileTypesToAccept"
           [attr.data-test-id]="[testId || '', 'input'].join('_')"
           (change)="fileBrowseHandler($event.target.files)" />
    <span class="icon icon-upload"></span>
    <span>
      <label for="fileDropRef_{{itemToLinkId || testId}}" [ngClass]="{'disabled' :isDisabled}">Choose files</label>
      <span class="label"> or drag and drop them here</span>
    </span>
  </div>
  <div class="files-list">
    <ng-container *ngFor="let file of files; let i = index">
      <div class="single-file d-flex no-wrap py-h pl-1 pr-1h mb-1 ai-center" *ngIf="!files[i].uploadFailed">
        <span class="icon icon-file d-flex col-auto p-0 pt-q"></span>
        <div class="info col">
          <span class="name medium row break-word">
            {{ file?.name || file?.fileName }}
          </span>
          <p class="row w-100 jc-between m-0">
            <span *ngIf="(file.size !== undefined || file.fileSize !== undefined) &&
                        (!file.status || file.status === ARTWORK_STATUSES.unreviewed)"
                  class="size m-0">
              {{ utilsService.getFormattedBytes(file.size !== undefined ? file.size : file.fileSize) }}
            </span>
            <span class="percent" *ngIf="file?.progress != null && file?.progress < 100">
              {{file?.progress + '%'}}
            </span>
          </p>
          <p *ngIf="file.status && file.status !== ARTWORK_STATUSES.unreviewed"
            class="my-0 mt-q row w-100 d-flex ai-center">
            <span class="status medium fs-xxs col-auto"
                  [ngClass]="{'approved': file.status === ARTWORK_STATUSES.approved,
                    'rejected': file.status === ARTWORK_STATUSES.rejected}">{{file.status}}</span>
            <span class="col color-cool-gray fs-xs">
              <span>{{file.reviewer.firstName}} {{file.reviewer.lastName}}</span>
              <span> {{file.updatedAt | date : 'MM/dd/yyyy, hh:mm a'}}</span>
            </span>
          </p>
          <p *ngIf="file.rejectionReason" class="my-0 mt-q row w-100 color-navi fs-xs">
            <span class="medium">{{'module.requests.upload.rejection-reason' | translate | uppercase}}:</span>
            <span class="ml-q wrap-length text-break">{{file.rejectionReason}}</span>
          </p>
          <app-file-upload-progress [file]="file"></app-file-upload-progress>
          <span class="fs-xs mr-h text-error" *ngIf="files[i].uploadFailed">Upload failed</span>
        </div>
        <div class="col-auto px-0 d-flex ai-center" *ngIf="isPreviewEnabled && (files[i].attachmentId || files[i].id)">
          <button type="button" *ngIf="files[i].progress === 100 && !files[i].uploadFailed"
                  [attr.data-test-id]="'file_preview_'+i" [ngClass]="{'mr-1': !isDisabled}"
                  [disabled]="false"
                  class="reset-button link-secondary px-0" (click)="openFileForPreview(i)">
            <span class="icon icon-view"></span>
          </button>
        </div>
        <div class="col-auto px-0 d-flex ai-center" *ngIf="files[i].attachmentId || files[i].id">
          <button type="button" *ngIf="files[i].progress === 100 && !files[i].uploadFailed"
                  [attr.data-test-id]="'file_download_'+i" [ngClass]="{'mr-1': !isDisabled}"
                  [disabled]="false"
                  class="reset-button link-secondary px-0" (click)="downloadFile(i)">
            <span class="icon icon-download"></span>
          </button>
        </div>
        <div class="col-auto px-0 d-flex ai-center" *ngIf="files[i].attachmentId || files[i].id">
          <span class="fs-xs mr-h" *ngIf="files[i].uploadFailed">Upload failed</span>
          <button type="button" *ngIf="files[i].progress === 100 && !isDisabled"
                  [attr.data-test-id]="'file_remove_'+i"
                  class="reset-button link-secondary px-0" (click)="deleteFile(i)">
            <span class="icon icon-delete"></span>
          </button>
        </div>
      </div>
    </ng-container>
    <button type="button" data-test-id="button_upload_more"
            [hidden]="!files.length"
            class="reset-button link p-0 medium pointer"
            (click)="fileDropRef.click()"
            [disabled]="isDisabled">
      <span class="icon icon-add"></span>
      <span *ngIf="moreLabel"> {{moreLabel}}</span>
      <span *ngIf="!moreLabel"> {{'common.label.upload-more' | translate}}</span>
    </button>
  </div>
  <div *ngIf="isRestrictionSizeWarningExist" class="color-warning d-flex ai-center">
    <span class="icon icon-warning fs-md"></span>
    <span class="ml-q">{{'common.restrictions.file-size-exceeded' | translate : {size: (restrictionOptions.fileSize.sizeNumber + restrictionOptions.fileSize.sizeType)} }}</span>
  </div>
</div>

